//
// https://www.tiny.cloud/
//
tinymce.init({
    schema: "html5-strict",
    selector: "textarea.message",
    browser_spellcheck : true,
    height: 300,
    element_format: "html",
    plugins: [
        "lists autolink link image charmap preview anchor",
        "searchreplace code advlist",
        "media nonbreaking table textcolor template"
    ],
    image_advtab: true,
    menubar: false,
    fix_list_elements: true,
    convert_fonts_to_spans: true,
    toolbar: "newdocument undo redo | preview code | bold italic underline strikethrough subscript superscript removeformat | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote table | link unlink image | charmap | forecolor backcolor | styleselect fontsizeselect",
    toolbar_mode: "wrap",
    link_list: [
        {title: 'Home', value: './index.php'},
        {title: 'Contacts', value: './contacts.php'},
        {title: 'Programme', value: './programme.php'},
        {title: 'Method', value: './method_library.php'}
    ],
    target_list: [
        {title: 'None', value: ''},
        {title: 'External', value: 'external'},
        {title: 'New page', value: '_blank'},
        {title: 'Same page', value: '_self'}
    ],
    style_formats: [
        {title : 'Header 1', block : 'h1'},
        {title : 'Header 2', block : 'h2'},
        {title : 'Header 3', block : 'h3'},
        {title : 'Header 4', block : 'h4'},
        {title : 'Header 5', block : 'h5'},
        {title : 'Header 6', block : 'h6'},
        {title : 'Paragraph', block : 'p'},
        {title : 'Blockquote', block : 'blockquote'},
        {title : 'Div', block : 'div'},
        {title : 'Pre', block : 'pre'}
    ],
    image_list: [
        {title: 'PDF Icon', value: './graphics/acrobat_sm.gif'},
        {title: 'Picture Icon', value: './graphics/camera_icon.gif'},
        {title: 'Video Icon', value: './graphics/media.gif'}
    ]
});
